/* TODO: t() */
import React from 'react';

import Button, { Props } from './Button';
import { FormContext } from './Form';

function SubmitButton(props: Props) {
  let { onPress, isPrimary, testID, ...otherProps } = props;
  return (
    <FormContext.Consumer>
      {(doSubmit) => (
        <Button
          {...otherProps}
          testID={testID}
          onPress={(event) => {
            onPress?.(event);
            doSubmit?.(event);
          }}
          isPrimary={isPrimary !== false}
        />
      )}
    </FormContext.Consumer>
  );
}

export default SubmitButton;
